import React from 'react';
import PropTypes from 'prop-types';
import { InflowsMoneyFlow } from './InflowsMoneyFlow';

export const InflowsMoneyFlows = ({ collection }) => {
  const resource = collection.resources().head();

  return (
    <InflowsMoneyFlow
      resource={resource}
    />
  );
};

InflowsMoneyFlows.propTypes = {
  collection: PropTypes.object.isRequired,
};

InflowsMoneyFlows.defaultProps = {};
